export default __webpack_public_path__ + "static/emphasise-metric-do-79182cefe9171ff1874036ba8644e520f558f7e59ece29ca14b00ebefcf7e995.png";